import React, { useState, useEffect } from "react"
import Reply from "../../../images/Reply.svg"
import * as Style from "../Comments.module.scss"
import Discussion from "../Discussion"

const ReplyComment = ({
  id,
  user_name,
  date_time,
  content,
  strapi_id,
  discussion,
  mode,
  position,
  mainId,
  original_post,
  original_author,
  nav_id,
  navigatePost,
  colorTargethandler,
  colorTarget,
}) => {
  const [showReply, setShowReply] = useState(false)
  // const [target, setTarget] = useState(false)

  let originalPost

  useEffect(() => {
    if (typeof document !== `undefined`) {
      originalPost = document.getElementById(`${navigatePost}`)
    }
  })

  const dateAndTime =
    new Date(date_time)
      .toLocaleString("en-GB", {
        timeZone: "Europe/Sofia",
      })
      .slice(0, -3)
      .replace(",", "") + " ч."

  const targethandler = () => {
    // colorTargethandler(navigatePost)
    if (originalPost) {
      originalPost.scrollIntoView({
        behavior: "auto",
        block: "center",
        inline: "center",
      })
      colorTargethandler(navigatePost)
    }
  }

  const showReplyhandler = () => {
    setShowReply(!showReply)
    if (!showReply) {
      colorTargethandler(null)
    }
  }

  const blurHandler = () => {
    setTimeout(() => {
      setShowReply(!showReply)
      // showReplyhandler()
    }, 100)
  }

  return (
    <div
      id={nav_id}
      key={id}
      className={`${Style.wholeCommentWrapper} ${
        Style.wholeSubCommentWrapper
      } ${colorTarget === nav_id ? Style.targetPost : ""}`}
    >
      <div className={Style.wrapper}>
        <div className={Style.avatar}></div>
        <div className={Style.nameContentWrap}>
          <div className={Style.nameOptions}>
            <div className={Style.name}>{user_name}</div>
            <div onClick={showReplyhandler} className={Style.options}>
              <div className={Style.replyIcon}>
                <Reply />
              </div>
              <div className={Style.reply}>Reply {id}</div>
            </div>
          </div>
          <div className={Style.content}></div>
        </div>
      </div>
      {position === "reply-sub" && (
        // <a onClick={targethandler} href={`#${navigatePost}`}>
        <div className={Style.navAn} onClick={targethandler}>
          <div className={Style.replyInfo}>
            @{original_author}{" "}
            <p className={Style.originalPost}>
              {`${original_post.substring(0, 50)}...`}{" "}
            </p>
          </div>
        </div>
      )}
      <p className={Style.contentText}>{content}</p>
      <p className={Style.dateTime}>{dateAndTime}</p>
      {showReply && (
        <Discussion
          showReply={showReply}
          blurHandler={blurHandler}
          nav_id={nav_id}
          original_post={content}
          mainId={mainId}
          strapi_id={strapi_id}
          discussion={discussion}
          mode={mode}
          user_name={user_name}
          close={showReplyhandler}
        />
      )}
    </div>
  )
}

export default ReplyComment
